import React, {useEffect, useId, useRef, type ReactNode, type RefObject} from "react";
import "./GridDialog.css";

export function GridDialog({title, onClose, children, className = "", initialFocusRef}: {title: string; onClose: () => void; children: ReactNode; className?: string; initialFocusRef?: RefObject<HTMLElement | null>}) {
  const ref = useRef<HTMLDialogElement>(null), titleId = useId();
  useEffect(() => {
    const element = ref.current, previousFocus = document.activeElement;
    element.showModal();
    initialFocusRef?.current?.focus();
    return () => {
      element.close();
      if (previousFocus instanceof HTMLElement && previousFocus.isConnected) previousFocus.focus();
    };
  }, [initialFocusRef]);
  return <dialog ref={ref} className={`grid-dialog ${className}`} aria-labelledby={titleId} onCancel={(event) => {event.preventDefault(); onClose();}}>
    <h2 id={titleId}>{title}</h2>{children}
  </dialog>;
}
